import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { QuickQuoteForm } from '../components/QuickQuoteForm';

export const DensitometriaPage = () => {
  const equipment = {
    name: "Densitometria Óssea",
    subtitle: "Sistema DEXA para Análise Óssea",
    description: "Sistemas precisos de medição de densidade óssea para diagnóstico e monitoramento de osteoporose. A densitometria óssea é o exame padrão-ouro para avaliação da massa óssea e risco de fraturas.",
    image: "https://customer-assets.emergentagent.com/job_7899ab28-0d6a-4e3b-b0e7-b178b443ae26/artifacts/ki2lh4ce_WhatsApp%20Image%202026-03-31%20at%2010.02.20%20AM.jpeg",
    features: [
      "Tecnologia DEXA de alta precisão",
      "Tempos de varredura rápidos",
      "Baixa dose de radiação",
      "Relatórios abrangentes",
      "Medições de alta precisão",
      "Análise de composição corporal"
    ],
    applications: [
      "Diagnóstico de osteoporose",
      "Monitoramento de tratamento",
      "Avaliação de risco de fraturas",
      "Análise de composição corporal",
      "Acompanhamento pós-menopausa",
      "Avaliação pediátrica"
    ]
  };

  return (
    <div className="min-h-screen pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-600 via-blue-700 to-cyan-600 py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-6">
            <h1 className="text-4xl sm:text-5xl font-bold text-white">
              {equipment.name}
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              {equipment.subtitle}
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div>
              <div className="rounded-2xl overflow-hidden shadow-xl bg-gray-100 sticky top-32">
                <img 
                  src={equipment.image} 
                  alt={equipment.name}
                  className="w-full h-96 object-cover"
                />
              </div>
            </div>
            <div className="space-y-8">
              <p className="text-lg text-gray-600">
                {equipment.description}
              </p>
              
              <div className="space-y-3">
                <h3 className="font-semibold text-gray-900 text-xl">Características:</h3>
                <ul className="space-y-2">
                  {equipment.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start space-x-3">
                      <CheckCircle className="text-green-500 flex-shrink-0 mt-0.5" size={20} />
                      <span className="text-gray-600">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <Card className="bg-gray-50">
                <CardContent className="p-6">
                  <h3 className="font-semibold text-gray-900 mb-4 text-xl">Aplicações Clínicas:</h3>
                  <div className="grid grid-cols-2 gap-3">
                    {equipment.applications.map((app, idx) => (
                      <div key={idx} className="flex items-center space-x-2">
                        <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                        <span className="text-gray-700">{app}</span>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>

              <QuickQuoteForm equipmentName={equipment.name} />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-600">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <div className="space-y-6">
            <h2 className="text-3xl sm:text-4xl font-bold text-white">
              Interessado em Densitometria Óssea?
            </h2>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto">
              Entre em contato para conhecer as opções disponíveis
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-6 text-lg">
                Fale Conosco
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
